import { realDataService } from './realDataService';

// Calculate dashboard summary statistics
export async function calculateDashboardSummary(userId?: string) {
  try {
    // Use real data service which handles both authenticated and guest users
    const dashboardData = await realDataService.getDashboardData(userId);
    
    return {
      totalPoints: dashboardData.totalPoints,
      totalValue: dashboardData.totalValue,
      totalValueUSD: dashboardData.totalValueUSD,
      exchangeRate: dashboardData.exchangeRate,
      lastUpdated: dashboardData.lastUpdated,
      pointsExpiringSoon: dashboardData.pointsExpiringSoon,
      recommendations: dashboardData.topRecommendations.length,
      isGuestMode: !userId,
    };
  } catch (error) {
    console.error('Error calculating dashboard summary:', error);
    return {
      totalPoints: 0,
      totalValue: 0,
      totalValueUSD: undefined,
      exchangeRate: undefined,
      lastUpdated: undefined,
      pointsExpiringSoon: 0,
      recommendations: 0,
      isGuestMode: !userId,
    };
  }
}